import { createFileRoute } from "@tanstack/react-router";

import { DownloadApp } from "@/features/my/download-app";

export const Route = createFileRoute("/(member)/(protected)/my/download-app")({
  component: DownloadApp,
});
